// @flow

// Action Types
const actionPrefix: string = '@@datatable/recommendations/'
export const SELECT_RECORDS = `${actionPrefix}SELECT_RECORDS`
export const UPDATE_FILTER = `${actionPrefix}UPDATE_FILTER`

// Datatable
export const DATATABLE_NAME = 'Recommendations'

// Record attrs
export const ATTR_RECOMMENDATION_ID = 'id'
export const ATTR_CROP = 'crop'
export const ATTR_YIELD_TARGET = 'yield_target'
export const ATTR_TARGET_PH = 'target_pH'
export const ATTR_RECOMMENDATION_TYPE = 'recommendation_type'
export const ATTR_CONTROLLER_TYPE = 'controller_type'
export const ATTR_ELEMENTS = 'elements'
export const ATTR_PRODUCTS = 'products'
export const ATTR_MAP_REPORTS = 'map_reports'
export const ATTR_CONTROLLER_FILES = 'controller_files'
export const ATTR_STATUS = 'status'
export const ATTR_CONTROLLER = 'controller'
export const ATTR_REMOVAL_CROP_GROWN = 'removal_crop_grown'
export const ATTR_REMOVAL_YIELD = 'removal_yield'
export const ATTR_PREVIOUS_CROP = 'previous_crop'
export const ATTR_CREDIT_OTHER_PRESCRIPTIONS = 'credit_other_prescriptions'
export const ATTR_RXRATES = 'rxRates'
export const ATTR_ASSET = 'asset'
export const ATTR_REMOVAL_CROP = 'removal_crop'
export const ATTR_HAS_MAP_REPORTS = 'hasMapReports'
export const ATTR_HAS_CONTROLLER_FILES = 'hasControllerFiles'

// Route
export const REPORTS_MAP_REPORT_ROUTE = '/reports/mapReport'

// Default values
export const DEFAULT_TARGET_PH = '6.5'
